/** Поля груп меню «за значеннями поля» (byField), для яких потрібна статистика-лічильники. */
import type { IRecordTypeDefinition } from '@platform/core/types';

/**
 * Ключі полів груп byField типу запису без повторів — лише поля, які є в типі й не приховані визначенням (група з іншим полем не рендериться,
 * і статистику за ним не запитуємо); `status` рахує окрема статистика за статусами. Чиста функція.
 */
export function menuFacetFields(rt: IRecordTypeDefinition): string[] {
  const keys = rt.menu.filter((g) => g.kind === 'byField' && g.field).map((g) => g.field as string);
  return [...new Set(keys)].filter((key) => key !== 'status' && rt.fields.some((f) => f.key === key && !f.hidden));
}
